<template>

  <div>
    <div class="bold-text" v-if="displayLabel">
      {{ label }}
    </div>
    <div class="mt-2">
      <div v-if="object && object.id && object.tostring">
        <b-link :href="'#' + route + object.id" target="_blank">{{object.tostring}}</b-link>
      </div>
      <div v-else>-</div>
    </div>
  </div>

</template>

<script>

export default {

  name: 'ShowObjectLinkValueField',

  props: {
    object: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    route: {
      type: String,
      default: null
    },
    displayLabel: {
      type: Boolean,
      default: true
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/showFields/ShowObjectLinkValueField.vue